import { render, staticRenderFns } from "./RequestMaterials.vue?vue&type=template&id=219f0c48"
import script from "./RequestMaterials.vue?vue&type=script&lang=js"
export * from "./RequestMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports